import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';
import * as $ from 'jquery';
import * as MySound from '../../MySound';
import ConfirmLocationChargeSkeleton from '../../ConfirmLocationChargeSkeleton';

export class RF_ConfirmPut extends Component {
    static displayName = RF_ConfirmPut.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            loading: false,
            fromLocationId: "",
            fromLocationBarcode:"",
            unitsToTransferIn: 0,
            unitsToMove:0,
            scannedProductBarcode: "",
            scannedInventory: "",
            createdDocket: 0,
            namecode: "",
            grade1: "",
            grade2: "",
            grade3: "",
            expiry: "",
            packing: "",
            productDescription2: "",
            locationData: "",
            displayConfirmChargePrompt: false,
            locationChargesConfirmedByUser: false,
            displayPromptOnFinish: false,
            clientName: ""
            
        }
    }

    componentDidMount() {
        if (MyGlobal.rf_transfer) {
            var rf_transfersettings = JSON.parse(MyGlobal.rf_transfer);
            if (rf_transfersettings) {
               
                this.state.namecode = rf_transfersettings.namecode;
                this.state.createdDocket = rf_transfersettings.createdDocket;
                this.state.fromLocationId = rf_transfersettings.fromLocationId;
              
                this.setState({
                    fromLocationId: rf_transfersettings.fromLocationId,
                    fromLocationBarcode: rf_transfersettings.fromLocationBarcode,
                    createdDocket: rf_transfersettings.createdDocket,
                    namecode: rf_transfersettings.namecode,
                    locationData: rf_transfersettings.locationData,
                    displayConfirmChargePrompt: rf_transfersettings.displayConfirmChargePrompt,
                    clientName : rf_transfersettings.clientName
                });
                if (MyGlobal.locationChargesConfirmedByUser && MyGlobal.locationChargesConfirmedByUser === true && MyGlobal.locationChargesConfirmed_LocationId === rf_transfersettings.fromLocationId) {
                    this.state.locationChargesConfirmedByUser = true;
                }
                else {
                    this.state.locationChargesConfirmedByUser = false;
                }
            }
        }
        if (this.props.location && this.props.location.state) {
            this.state.scannedProductBarcode = this.props.location.state.scannedProductBarcode;
            this.state.scannedInventory = this.props.location.state.scannedInventory;
            this.state.unitsToTransferIn = this.props.location.state.unitsToTransferIn;
            this.state.unitsToMove = this.props.location.state.unitsToTransferIn;
        }
        this.getProductAttributes();
    }

    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }
    async putInventoryInLocation(scannedProductBarcode) {


        if (!scannedProductBarcode) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Product barcode" });
            return;
        }
        if (this.state.fromLocationId <= 0) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please scan the Transfer To Location" });
            return;
        }
        const inventory = this.state.scannedInventory;
        if (!inventory) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Inventory with barcode: " + scannedProductBarcode + " not found in the list of inventories for this location" });
            return;
        }

        this.state.unitsToMove = typeof this.state.unitsToMove === 'string' ? this.state.unitsToMove.trim() : this.state.unitsToMove;

        if (!this.state.unitsToMove || isNaN(this.state.unitsToMove) || parseFloat(this.state.unitsToMove) <= 0 || !Number.isInteger(parseFloat(this.state.unitsToMove))) {
            MySound.play(MySound.Sound.stop);
            this.setState({ alertMessage: "Please enter a valid whole number for the units to load into the new Location" });
            return;
        }

      

        this.setState({ alertMessage: "" });
        this.state.loading = true;
        const adhocTransferRequestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                LocationId: this.state.fromLocationId,
                Namecode: this.state.namecode,
                Docket: this.state.createdDocket,
                ProductBarcode: inventory.barcode,
                Units: this.state.unitsToMove,
                WarehouseId: MyGlobal.warehouse,
                StaffName: MyGlobal.staffName
            })
        };
        fetch('api/Transfer/PutInventoryInLocation', adhocTransferRequestOptions)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    MySound.play(MySound.Sound.stop);
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Transfer Failed - " + errorText });
                }
                else {

                    if (!data.success) {
                        MySound.play(MySound.Sound.stop);
                        this.setState({ alertMessage: "Transfer Failed - " + data.responseText });
                    }
                    else {
                        this.setState({ alertMessage: data.responseText });
                        if (this.state.displayConfirmChargePrompt === true) {

                            this.setState({ displayPromptOnFinish: true });
                        }
                        else {
                            MySound.play(MySound.Sound.next);
                            this.goto('RF_SelectAction');
                        }
                        
                    }
                }
            })
            .catch(error => {
                MySound.play(MySound.Sound.stop);
                this.state.loading = false;
                this.setState({ inventories: [], alertMessage: error });
            });
    }

    async getProductAttributes() {

        if (!this.state.namecode) {
            this.setState({ alertMessage: "Namecode is required to get Product attributes" });
            return;
        }
        if (!this.state.createdDocket) {
            this.setState({ alertMessage: "Docket Number is required to get Product attributes" });
            return;
        }
        const inventory = this.state.scannedInventory;
        if (!inventory || !inventory.productID) {
            this.setState({ alertMessage: "ProductId is required to get Product attributes" });
            return;
        }
        this.state.loading = true;
        const getProductAttributeRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Namecode: this.state.namecode,
                Docket: this.state.createdDocket,
                ProductId: inventory.productID
            })
        };
        fetch('api/Transfer/GetProductAttributes', getProductAttributeRequest)
            .then(async response => {
                this.state.loading = false;
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const apiResponse = isJson ? await response.json() : null;

                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: "Failed to get product attributes!! " + errorText });
                }
                else {

                    if (!apiResponse.success) {
                        this.setState({ alertMessage: "Failed to get product attributes!! " + apiResponse.errorMessage });
                    }
                    else {
                        const data = apiResponse.data;
                        this.setState({
                            grade1: data.grade1,
                            grade2: data.grade2,
                            grade3: data.grade3,
                            expiry: data.expiry,
                            packing: data.packing,
                            productDescription2: data.description2
                        });
                        return;
                    }
                }
            })
            .catch(error => {
                this.state.loading = false;
                this.setState({ alertMessage: "Failed to get product attributes!! " + error });
            });
    }

    confirmLocationCloseEvent() {

        this.setState({ displayConfirmChargePrompt: false, locationChargesConfirmedByUser: true });
        MyGlobal.locationChargesConfirmedByUser = true;
        MyGlobal.locationChargesConfirmed_LocationId = this.state.fromLocationId;
        this.goto('RF_SelectAction');
    }
    render() {

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        let displayPrompt = this.state.displayConfirmChargePrompt === true && this.state.displayPromptOnFinish === true;
        displayPrompt = displayPrompt === true ? <ConfirmLocationChargeSkeleton show={this.state.displayConfirmChargePrompt} locationData={this.state.locationData} onClickClose={() => { this.confirmLocationCloseEvent(); }}  ></ConfirmLocationChargeSkeleton> : "";

        const handleInputKeypress = e => {
            //it triggers by pressing the enter key
            if (e.keyCode === 13 || e.charCode === 13 || e.which === 13) {
                this.putInventoryInLocation(this.state.scannedProductBarcode);
            }
        };

        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('RF_Put'); }} >
                                Back
                            </button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><h4>Confirm Put</h4></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col><label>Confirm Qty to Put :</label></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}>
                            <input ref="unitInput" className="form-control" placeholder="Enter units"
                                value={this.state.unitsToMove}
                                onChange={(e) => {
                                    this.setState({ unitsToMove: e.target.value });
                                }}
                                readOnly={this.state.sending} onKeyPress={handleInputKeypress} ></input>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>
                            <button type="button" className="btn btn-success col-12" onClick={() => { this.putInventoryInLocation(this.state.scannedProductBarcode); }}  >Next</button>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={12}><h5>Product Details</h5></Col>
                    </Row>
                    {[
                        { label: "Client", value: this.state.clientName },
                        { label: "Code", value: this.state.scannedInventory.productCode },
                        { label: "Barcode", value: this.state.scannedInventory.barcode },
                        { label: "Description", value: this.state.scannedInventory.productDescription },
                        { label: "Description 2", value: this.state.scannedInventory.productDescription2 },
                        { label: "Grade1", value: this.state.grade1 },
                        { label: "Grade2", value: this.state.grade2 },
                        { label: "Grade3", value: this.state.grade3 },
                        { label: "Expiry", value: this.state.expiry },
                        { label: "Packing", value: this.state.packing },
                        { label: "Picked Qty", value: this.state.unitsToTransferIn },
                    ].map((item, index) => (
                        <Row className="mb-3" key={index}>
                            {/* Adjust column widths for different screen sizes */}
                            <Col xs={6} md={5} lg={5}>{item.label} :</Col>
                            <Col xs={6} md={7} lg={7}>{item.value || ""}</Col>
                        </Row>
                    ))}

                </Container>
                {displayPrompt}
            </div>
        );
    }
}